module.exports = __webpack_public_path__ + "img/md-radio.f85bf3de.svg";